import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AUTH_SERVICE_TOKEN, IAuthService } from '../services/auth/auth-service.interface';

@Injectable()
export class GuestGuard  {
  constructor(private router: Router, @Inject(AUTH_SERVICE_TOKEN) private authService: IAuthService) {}

  canActivate(): boolean {
    if (!this.authService.isAuthorized()) {
      return true;
    }
    this.router.navigate(['/']);

    return false;
  }
}
